<!-- Global Alerts Layout (Error & Success Floating Notifications Container) -->
<div class="position-fixed top-0 end-0 p-3 z-3 d-flex flex-column gap-2" style="max-width: 350px;">
    @if (errorMessage()) {
    <div class="alert alert-danger alert-dismissible shadow border-danger border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
        role="alert">
        <i class="bi bi-exclamation-triangle-fill flex-shrink-0 text-danger fs-5"></i>
        <div class="small lh-sm flex-grow-1 pe-2">
            <strong>Execution Error:</strong> {{ errorMessage() }}
        </div>
        <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
            aria-label="Close"></button>
    </div>
    }

    @if (successMessage()) {
    <div class="alert alert-success alert-dismissible shadow border-success border-opacity-25 fade show d-flex align-items-center gap-2 m-0 font-monospace py-2.5"
        role="alert">
        <i class="bi bi-check-circle-fill flex-shrink-0 text-success fs-5"></i>
        <div class="small lh-sm flex-grow-1 pe-2">
            {{ successMessage() }}
        </div>
        <button type="button" class="btn-close shadow-none top-50 translate-middle-y my-0 end-0 me-2"
            aria-label="Close"></button>
    </div>
    }
</div>

<header class="d-flex flex-wrap align-items-center justify-content-between gap-3 p-3 border shadow-sm bg-body-tertiary">

    <div class="d-flex align-items-center gap-2">
        <div>
            <button type="button"
                class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
                (click)="goBack()">
                <i class="bi bi-arrow-left"></i>
                <span>Back</span>
            </button>
        </div>


        <button type="button"
            class="btn btn-sm btn-primary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm fw-semibold"
            data-bs-toggle="modal" data-bs-target="#addNewCatalog">
            <i class="fa-solid fa-plus font-xs"></i>
            <span>Add New Catalog</span>
        </button>
    </div>

</header>

<!-- Responsive Table Outer Box -->
<div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 transition-base">
        <thead class="table-light border-bottom font-monospace small text-uppercase tracking-wider text-body-secondary">
            <tr>
                <th class="ps-4 py-3" style="width: 80px;">No</th>
                <th class="py-3">Catalog Name</th>
                <th class="py-3 text-center" style="width: 180px;">Status</th>
                <th class="pe-4 py-3 text-end" style="width: 120px;">Actions</th>
            </tr>
        </thead>

        <tbody class="small text-body">
            @for (catalog of courseCatalogList() | paginate : { itemsPerPage: pageSize(), currentPage: page(),
            totalItems: allTotal() }; track catalog.id) {

            <tr class="transition-base" [class.table-active]="editingId() === catalog.id">
                <!-- Serial Number -->
                <td class="ps-4 font-monospace fw-semibold">{{ catalog.srNo }}</td>

                <!-- Catalog Name Cell Layer -->
                <td class="py-2">
                    @if (editingId() === catalog.id) {
                    <div class="d-flex align-items-center gap-2" style="max-width: 350px;">
                        <input type="text" #editInputFocus
                            class="form-control form-control-sm bg-body text-body-emphasis border-primary shadow-sm focus-ring"
                            style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" [(ngModel)]="catalog.name"
                            (keyup.enter)="submitInlineUpdate(catalog)" (keyup.escape)="cancelInlineEdit()"
                            autocomplete="off" />

                        <button type="button" class="btn btn-sm btn-success px-2 py-1"
                            (click)="submitInlineUpdate(catalog)" [disabled]="apiLoading()">
                            <i class="fa-solid fa-check"></i>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary px-2 py-1"
                            (click)="cancelInlineEdit()" [disabled]="apiLoading()">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                    } @else {
                    <span class="fw-bold text-body-emphasis">{{ catalog.name }}</span>
                    }
                </td>

                <!-- Status Slider Indicator Cell -->
                <td class="text-center">
                    <div class="d-inline-flex align-items-center gap-2">
                        <span class="badge font-monospace px-2.5 py-1.5 rounded-pill border fw-bold tracking-wider"
                            [ngClass]="catalog.enabled ? 'bg-success-subtle text-success-emphasis border-success-subtle' : 'bg-danger-subtle text-danger-emphasis border-danger-subtle'">
                            {{ catalog.enabled ? 'Active' : 'Disabled' }}
                        </span>
                        <div class="form-check form-switch custom-ios-switch m-0 p-0">
                            <input class="form-check-input" type="checkbox" role="switch" [checked]="catalog.enabled"
                                [disabled]="apiLoading()" (change)="toggleCatalogStatus(catalog)">
                        </div>
                    </div>
                </td>

                <!-- Clear Minimal Context Actions Column -->
                <td class="pe-4 text-end">
                    <div class="d-inline-flex gap-1">
                        @if (editingId() !== catalog.id) {
                        <!-- Modify Button -->
                        <button type="button"
                            class="btn btn-sm btn-outline-secondary border-0 p-1.5 rounded-2 text-body-secondary focus-ring"
                            style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.15)" title="Edit Catalog Name"
                            [disabled]="apiLoading()" (click)="startInlineEdit(catalog)">
                            <i class="fa-solid fa-pen-to-square fs-6"></i>
                        </button>
                        }
                    </div>
                </td>
            </tr>
            } @empty {
            <tr>
                <td colspan="4" class="py-5 text-body-secondary">
                    <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                        <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                        <span class="tracking-wider">No Course Catalogs found.</span>
                    </div>
                </td>
            </tr>
            }
        </tbody>
    </table>


    <div class="card-footer bg-transparent border-top py-2.5">
        <div class="d-flex justify-content-center">
            <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
                class="dashboard-pagination" (pageChange)="handlePageChange($event)">
            </pagination-controls>
        </div>
    </div>

</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
    style="backdrop-filter: blur(4px);">
    <!-- Mini Spinner -->
    <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    <!-- Text Badge Layout (Uses your global micro utilities) -->
    <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
        Loading...
    </div>
</div>
}

<div class="modal fade" id="addNewCatalog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow-lg border-0 bg-body">
            <!-- Modal Header -->
            <div class="modal-header border-bottom px-4 py-3">
                <h5 class="modal-title fw-bold text-gradient-primary">
                    <i class="fa-solid fa-circle-plus me-2"></i>Add New Catalog
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body px-4 py-4 d-flex flex-column gap-3">
                <div>
                    <label
                        class="form-label font-xs fw-bold text-body-secondary text-uppercase tracking-wider mb-1.5">Catalog
                        Name</label>

                    <input type="text" class="form-control form-control-sm shadow-sm" placeholder="Enter Catalog Name"
                        [(ngModel)]="catalogName" />
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer border-top px-4 py-2.5">
                <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
                    data-bs-dismiss="modal">Close</button>
                <button type="button"
                    class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
                    (click)="createCatalog()" [disabled]="!catalogName()">
                    @if (apiLoading()) {
                    <span class="spinner-border spinner-border-sm" role="status"></span>
                    } @else {
                    <span>Submit <i class="fa-solid fa-paper-plane font-xs"></i></span>
                    }

                </button>
            </div>
        </div>
    </div>
</div>